import store from 'config/store'
import { isEndUserMessage } from 'modules/message/utils'
import { find, isNil,pathOr, values } from 'ramda'
import { ConversationId } from 'types/conversation'
import { Message } from 'types/message'

/**
 * Gets the message list for the active conversation
 */
export const getActiveConversationMessages = (): Message[] => {
  const { conversations = {} } = store.getState()
  const activeConversationId: ConversationId = conversations.activeConversation

  if (!activeConversationId) {
    return []
  }

  return getConversationMessages(activeConversationId)
}


/**
 * Given a conversationId, grab the messages that exist for it in the redux store
 * @param conversationId - id of a given conversation
 */
export const getConversationMessages = (conversationId: ConversationId): Message[] => {
  const { conversations = {} } = store.getState()
  const conversationMessages = pathOr({}, ['messages', conversationId], conversations)

  return values(conversationMessages)
}

/**
 * Given a conversationId, return true if there are end user messages in the conversation - false otherwise
 * @param conversationId '
 */
export const conversationHasEndUserMessages = (conversationId: ConversationId): boolean => {
  const conversationMessages = getConversationMessages(conversationId)

  if (!conversationMessages || !conversationMessages.length) {
    return false
  }

  const endUserMessage = find((message) => isEndUserMessage(message), conversationMessages)
  return !isNil(endUserMessage)
}

/**
 * Grabs the active conversation in state and determines if there have been any end user messages in that conversation
 */
export const hasActiveConversationBeenInteractedWith = () => {
  const { conversations = {} } = store.getState()
  const activeConversationId: ConversationId = conversations.activeConversation

  if (!activeConversationId) {
    return false
  }

  return conversationHasEndUserMessages(activeConversationId)
}
